import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import { DARK_NAVY_FONT_COLOR, FONT_FAMILY_BOLD, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, SEMANTIC_TEXT_PX, TITLE_FONT_COLOR, X_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

export const FilterComponentWrapper = styled.div`
    background: #ffff;
    margin-bottom: 10px;
    margin-left: 16px;
    margin-right: 16px;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
`;

export const FilterWrapperMain = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 400px;
    height: ${({ isOrderResultPopUp, bannerHeight }) =>
        isOrderResultPopUp 
            ? bannerHeight
                ? `calc(71vh - ${bannerHeight})`
                : '71vh'
            : bannerHeight
            ? `calc(78vh - ${bannerHeight})`
            : '78vh'};
    align-self: center;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    overflow: hidden;
    z-index: 3000;
    ${media.mediumDevice`
        width: 360px;
    `}
    ${media.mobileDevice`
		height: ${({viewportHeight}) => viewportHeight ? `${viewportHeight}px` : '100vh'} !important;
		width: 100vw !important;
		max-width: none !important;
        padding-bottom: ${({ keyboardPaddingBottom }) => keyboardPaddingBottom};
    `}

    @media screen and (orientation: landscape) and (max-width: 1366px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(70vh - ${bannerHeight})` : '70vh'};
    }
    @media screen and (orientation: landscape) and (max-width: 1024px) {
        height: ${({bannerHeight}) =>
        bannerHeight ? `calc(70vh - ${bannerHeight})` : '70vh'};
    }
    @media screen and (orientation: landscape) and (max-height: 576px) and (pointer: coarse) {
		height: ${({viewportHeight}) => viewportHeight ? `${viewportHeight}px` : '100vh'} !important;
        width: 100vw !important;
        max-width: none !important;
    }
`;

export const FilterContentMain = styled.div`
    display: flex;
    flex-direction: column;
    background: #f5f5f5 !important;
    height: 100vh;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    ${scrollBarStyle}
`;

export const FilterHeading = styled.p`
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: 24px;
    font-family: ${FONT_FAMILY_BOLD};
    margin: 0;
    letter-spacing: 0;
`;

export const Reset = styled.p`
    color: ${TITLE_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0;
    padding-right: 1.3em;
    align-self: center;
    &:hover {
        cursor: pointer;
    }
`;

export const FilterHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-left: 24px;
    margin-top: 11px;
    margin-right: 24px;
    margin-bottom: 7px;
`;
export const FilterFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding-right: 14px;
    padding-left: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: #ffff;
    position: static;
    bottom: 0px;
    box-sizing: border-box;
    width: 100%;
    height: 10%;
`;

export const FooterCloseButton = styled.button`
    height: 38px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    border: 1px solid #1010eb;
    background: #ffff;
    align-content: center;
    width: 40%;
    &:hover {
        cursor: pointer;
    }
`;

export const FooterApplyButton = styled.button`
    height: 38px;
    background: ${(props) => (props.applyButton ? '#1010EB' : '#3c3c3c')};
    border-radius: 5px;
    display: flex;
    justify-content: center;
    width: 40%;
    opacity: 1;
    border: none;
    &:hover {
        cursor: pointer;
    }
`;

export const TextBold = styled.div`
    text-align: left;
    font-family: ${FONT_FAMILY_DEMI};
    color: ${(props) => props.color};
    font-size: ${SEMANTIC_TEXT_PX};
    margin-top: 0px;
    margin-bottom: 0px;
    letter-spacing: -0.12px;
    display: flex;
    align-self: center;
    margin: 0;
    padding: 0;
`;

export const FilterBlock = styled.div`
    top: 5rem;
    right: 2rem;
    ${media.smalDevice`
		top: ${({ isOrderResultPopUp }) => (isOrderResultPopUp ? '7%' : '0')};
		left: ${({ isOrderResultPopUp }) => !isOrderResultPopUp && '0'};
		margin-top:0;
        right:${({ isOrderResultPopUp }) =>
            isOrderResultPopUp ? '15px' : '0'};
	`}
    z-index: 3000;
    background: #f5f5f5;
    opacity: 1;
    position: ${({ isOrderResultPopUp }) => isOrderResultPopUp && 'absolute'};
    @media screen and (orientation: landscape) and (max-height: 576px) and (pointer: coarse) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        height: 100vh;
    }
`;

export const FooterWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-evenly;
`;
export const EmptyBox = styled.div`
    margin: 5%;
    ${media.smalDevice`
        margin: 150px;
    `}
    ${media.mobileDevice`
        margin: ${({ mobileMargin }) => mobileMargin};
    `}
`;

export const FilterComponentHeaderFooter = styled.div`
    background: #ffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: ${(props) => (props.padding ? props.padding : '28px')};
    padding-right: 19px;
    padding-top: 18px;
    padding-bottom: 20px;
    border-radius: 6px;
    align-items: center;
    cursor: pointer;
`;

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 1px solid #eee;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
`;

export const FilterItemDiv = styled.div`
    display: grid;
    grid-template-columns: auto 30% 16px;
    width: 100%;
`;

export const FilterAccountNameDiv = styled.div`
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
    width: 100%;
    grid-column: 1/2;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const FilterAccountNumberDiv = styled.div`
    min-width: 30%;
    font-style: italic;
    grid-column: 2/3;
    text-align: right;
    white-space: nowrap;
`;

export const FilterFavouriteIconDiv = styled.div`
    grid-column: 3/-1;
    align-items: center;
    display: flex;
    justify-content: center;
`;

export const SearchBoxContainer = styled.div`
    width: 100%;
    margin: 0;
    display: 'flex';
    justify-content: space-between;
    font-family: ${FONT_FAMILY_REGULAR};
    text-align: left;
    color: ${DARK_NAVY_FONT_COLOR};
    align-items: center;
    ${media.mobileDevice`
        padding: 0px 17px 10px 25px;
    `};

    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        right: 19%;
        // @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (orientation : portrait) {
        //     right: 12%;
        // }
        // @media only screen and (max-device-width: 490px) and (orientation : portrait) {
        //     right: 2.25rem !important;
        //     padding-right:15px;
        //     }
    }

    .p-input-icon-right > i:last-of-type,
    .p-input-icon-right > svg:last-of-type,
    .p-input-icon-right > .p-input-suffix {
        // right: 12%;
    }
`;

export const FilterPhysicianNameDiv = styled.div`
    width: 100%;
    grid-column: 1/2;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;


export const OrderStatusGroup = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    letter-spacing: 0px;
    color: #9d9d9d;
    text-transform: uppercase;
    opacity: 1;
    display: flex;
    width: 100%;
    font-size: ${X_SMALL_TEXT_PX};
    justify-content: left;
    align-items: center;
    padding-left: 28px;
`;
